import type { CrudFilters, LogicalFilter } from '@refinedev/core';

import { mapOperator } from './map-operator';

const replaceDateRangeFilterWithFromTo = (
  field: string,
  value: LogicalFilter[],
  queryFilters: Record<string, unknown>,
): boolean => {
  if (!Array.isArray(value)) {
    return false;
  }

  const [from, to] = value;
  const fromFiledName = `${field}From`;
  const toFiledName = `${field}To`;

  if (
    !field.toLowerCase().includes('createdon') &&
    !field.toLowerCase().includes('changestatusat')
  ) {
    return false;
  }

  if (from) {
    queryFilters[fromFiledName] = from;
  }
  if (to) {
    queryFilters[toFiledName] = to;
  }

  return true;
};

export const generateFilter = (filters?: CrudFilters, _?: string) => {
  const queryFilters: { [key: string]: string } = {};

  if (filters) {
    filters.map(filter => {
      if (filter.operator === 'or' || filter.operator === 'and') {
        throw new Error(
          `[@refinedev/simple-rest]: \`operator: ${filter.operator}\` is not supported. You can create custom data provider. https://refine.dev/docs/api-reference/core/providers/data-provider/#creating-a-data-provider`,
        );
      }

      if ('field' in filter) {
        const { field, operator, value } = filter;

        if (field === 'q') {
          queryFilters[field] = value;
          return;
        }

        if (replaceDateRangeFilterWithFromTo(field, value, queryFilters)) {
          return;
        }

        const mappedOperator = mapOperator(operator);
        queryFilters[`${field}${mappedOperator}`] = value;
      }
    });
  }

  return queryFilters;
};
